import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { forwardRef, useEffect, useState } from 'react';
import { selectFieldValueI18n } from '@icp/form-renderer-core';
import { InputAdornment, TextField } from '@mui/material';
import { composeEventAsync } from '@icp/utils';
import { useSelector } from '../../../store';
import { ValueLanguageSelectMaterial } from '../../../ValueLanguageSelect';
import InputClearButton from './InputClearButton';

const I18nInputMulti = forwardRef(function I18nInputMulti(props, ref) {
  const {
    value: valueProp,
    onBlur,
    onChange,
    id,
    readonly,
    allowClear,
    onClear,
    ...other
    //
  } = props;

  const { i18n } = useTranslation();

  const [valueLanguage, setValueLanguage] = useState(i18n.language);
  const valueI18n = useSelector(selectFieldValueI18n(id, valueLanguage));
  const [value, setValue] = useState(valueI18n);

  useEffect(() => {
    setValue(valueI18n);
  }, [valueI18n]);

  return (
    <TextField
      {...other}
      fullWidth={true}
      value={value ?? ''}
      onChange={(event) => setValue(event.target.value)}
      onBlur={composeEventAsync(() => onChange(value, valueLanguage), onBlur)}
      InputProps={{
        readOnly: readonly,
        startAdornment: (
          <InputAdornment position="start">
            <ValueLanguageSelectMaterial value={valueLanguage} onChange={setValueLanguage} />
          </InputAdornment>
        ),
        endAdornment:
          !readonly && valueI18n && allowClear ? <InputClearButton onClear={onClear} /> : null,
      }}
      ref={ref}
    />
  );
});

I18nInputMulti.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  readonly: PropTypes.bool,
  allowClear: PropTypes.bool,
  onClear: PropTypes.func,
};

export default I18nInputMulti;
